import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClientIcon from '@material-ui/icons/People';
import OpenIcon from '@material-ui/icons/OpenInNew';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Client from '../client/Client';

import './ClientResume.css';

class ClientResume extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
        };
    }

    handleClickOpen = () => {
        this.setState({ dialogOpen: true });
    };

    handleClose = () => {
        this.setState({ dialogOpen: false });
    };

    componentDidUpdate(prevProps, prevState) {
        console.log(prevProps);
        console.log(prevState);
        console.log(document.getElementById("clientDialog"));
    }

    renderDialogClient() {
        if (this.state.dialogOpen) {
            return (<Dialog
                id="clientDialog"
                fullScreen={false}
                open={this.state.dialogOpen}
                onClose={this.handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <Client numeroClient={this.props.clientResume.numero} popin={true} />
            </Dialog>);
        }
    }

    render() {
        return (
            <div className="clientResume">
                <div className="inlineInputs">
                    <div><h4><ClientIcon className="iconeButton" /> <span>Client</span></h4></div>
                    <div>
                        <div className="numeroClient">
                            {this.renderDialogClient()}
                            <a onClick={this.handleClickOpen}>
                                <span>{this.props.clientResume.numero}</span> <OpenIcon className="iconeButton" />
                            </a>
                        </div>
                    </div>
                </div>
                <div>
                    {this.props.clientResume.ligne1}
                </div>
                <div>
                    {this.props.clientResume.ligne2}
                </div>
            </div >);
    }
}

ClientResume.propTypes = {
    clientResume: PropTypes.object,
};

export default ClientResume


// WEBPACK FOOTER //
// ./src/components/content/devis/ClientResume.js